import { CurrencyExchangeDetails } from 'models/exchange-transfer-calculate'
import { DEFAULT_BASE_AMOUNT, DEFAULT_COUNTER_AMOUNT } from '../config'

export * from '../config'

export const DISCOUNT_RATE = 0

export const DEFAULT_EXCHANGE_DATA: CurrencyExchangeDetails = {
  baseAmount: DEFAULT_BASE_AMOUNT,
  counterAmount: DEFAULT_COUNTER_AMOUNT,
  baseCurrency: 'EUR',
  counterCurrency: 'PLN',
  direction: 'forward',
}
